export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9662.f6ce3ab7.jpg";